// TODO: Need Audit Separate Constructor
export default class ShowMoreContent {
  constructor(containerSelector, readMoreSelector, fullContentSelector) {
    $(containerSelector).on('click', readMoreSelector, function(event){
      var parent = $(event.target).parent();
      parent.siblings(fullContentSelector).removeClass('hidden');
      parent.hide();

      return false;
    });
  }
}
